import { Badge } from '@folio/components/ui/badge';
import type { DocumentFraudScoreDto } from 'korint-sdk';
import { useTranslation } from 'react-i18next';
import { FRAUD_STATUS_TONE, effectiveFraudStatus } from './fraudStatus';

export function FraudStatusBadge({ fraud }: { fraud: DocumentFraudScoreDto }) {
  const { t } = useTranslation();
  const status = effectiveFraudStatus(fraud);
  const detail = fraud.managerVerdict
    ? t('documentReview.fraud.review.manual')
    : fraud.fraudScore !== null
      ? t('documentReview.fraud.scoreOutOf', { score: fraud.fraudScore })
      : undefined;

  return (
    <Badge variant="light" tone={FRAUD_STATUS_TONE[status]} className="whitespace-nowrap">
      {t(`documentReview.fraud.status.${status}`)}
      {detail && ` · ${detail}`}
    </Badge>
  );
}
